import { Toolbar } from "ngx-editor";

export class AppConstants {
   EmptyGuid = '00000000-0000-0000-0000-000000000000';
   fileTypes = {
      image: ['.jpg', '.jpeg', '.png', '.gif'],
      //video: ['.mp4', '.avi', '.mov'],
      //audio: ['.mp3', '.wav'],
      document: ['.pdf', '.doc', '.docx', '.xls', '.xlsx'],
      presentation: ['.ppt', '.pptx'],
      archive: ['.zip', '.rar'],
      text: ['.txt']
   };
   fileExtensions = [
      '.csv', '.doc', '.docx', '.gif', '.jpeg', '.jpg', '.pdf', '.png',
      '.ppt', '.pptx', '.rar', '.txt', '.xls', '.xlsx', '.zip'
   ];
   richTextEditorToolBar : Toolbar= [
   ['bold', 'italic'],
   ['underline', 'strike'],
   ['code', 'blockquote'],
   ['ordered_list', 'bullet_list'],
   [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
   ['link'],
   ['text_color', 'background_color']
   ];
   signTypes: { key: string, value: string }[] = [{ key: 'esign', value: 'E-Signature' }, { key: 'ssign', value: 'S-Signature' }];
   disputeStatus = {
      NOT_RAISED: 'NOT_RAISED',
      RAISED: 'RAISED',
      IN_REVIEW: 'IN_REVIEW',
      RESOLVED: 'RESOLVED'
   };
    disputeAction = {
      SAVE: 'SAVE',
      SUBMIT: 'SUBMIT'      
   };
   disputeFileConfig = {
      maxFileSizeInMB: 10,
      maxFileSizeLimitUnit: 'MB',
      fileExtensions: [
       '.doc', '.docx',  '.pdf', '.ppt', '.pptx', '.txt', '.xls', '.xlsx'
      ]
   };
   
    providerTypes= {
      SCO: 'SCO',
      RESIDENTIAL_PROVIDER: 'RS',
      Demo:"DM"
   };


}